import React, { useEffect } from "react";
import { Button, Modal, Form, Input, message } from "antd";
import API from "../../../../services/api-request";
import SelectRFID from "../../../../components/SelectRFID";
import SelectTypePallet from "../../../../components/SelectTypePallet";

const EditPallet = (props) => {
  const [editForm] = Form.useForm();

  const onFinish = async (values) => {
    const { rfid_id, name, type } = values;

    const dataForm = {
      rfid_id,
      name,
      type,
    };

    await API.Put(`pallet/${props.selectedData.id}`, dataForm)
      .then(() => {
        message.success("Pallet has been edited");
        props.onGetPallet();
        editForm.resetFields();
        props.onShowEdit(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowEdit(false);
    editForm.resetFields();
  };

  useEffect(() => {
    editForm.setFieldsValue(props.selectedData);
    console.log(props.selectedData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedData]);

  useEffect(() => {
    if (!props.showEdit) {
      editForm.resetFields();
    }
  }, [props.showEdit]);

  return (
    <>
      <Modal
        title="Edit Pallet"
        open={props.showEdit}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => editForm.submit()}>
            Save
          </Button>,
        ]}
      >
        <Form
          form={editForm}
          name="Edit Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="No. RFID"
            name="rfid_id"
            rules={[{ required: true, message: "Please input No. RFID!" }]}
          >
            <SelectRFID />
          </Form.Item>
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Please input name!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Tipe Pallet"
            name="type"
            rules={[{ required: true, message: "Please input Tipe Pak!" }]}
          >
            <SelectTypePallet />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EditPallet;
